/*
 *  AdminTopActionBar.jsx
 *
 */
//==============================================================================
// External dep.
//==============================================================================
import React from "react";
import { Button as BtnPrimary } from "@talentbait/shared-components";
import { useTranslation } from "react-i18next";
//------------------------------------------------------------------------------
// Main Functional Component
//------------------------------------------------------------------------------
const AdminTopActionBar = ({ orgaId, campaignId, clientView, adsetId }) => {
  const { t } = useTranslation();

  return (
    <>
      <a href={`${window.baseUrlInteralTools}/admin-campaign/${orgaId}/${campaignId}`}>
        <BtnPrimary
          type="tertiary"
          size="medium"
          variant="outline"
          weight="light"
          px="15px"
          mr="10px"
        >
          {t("Back to Campaign")}
        </BtnPrimary>
      </a>
      {/* <AdminClientViewButton campaignId={campaignId} clientView={clientView} adsetId={adsetId} /> */}
      <a
        href={`${window.baseUrlInteralTools}/admin/creatives/${campaignId}/${adsetId}`}
        target="_blank"
        rel="noreferrer"
      >
        <BtnPrimary
          type="tertiary"
          size="medium"
          variant="outline"
          weight="light"
          px="15px"
          mr="10px"
        >
          {t("Open Admin View")}
        </BtnPrimary>
      </a>
      <a
        href={`${window.baseUrlInteralTools}/admin/campaign/media?campaignId=${campaignId}`}
        target="_blank"
        rel="noreferrer"
      >
        <BtnPrimary type="tertiary" size="medium" variant="outline" weight="light" px="15px">
          {t("Open Media Generator")}
        </BtnPrimary>
      </a>
    </>
  );
};

export default AdminTopActionBar;
